import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { useState, useEffect } from "react";

const InstagramSliderWrap = ({ blok }) => {
  //ImageSlider

  const [arrowRightVisibility, setVisibilityArrwoRight] = useState("unset");
  const [arrowLeftVisibility, setVisibilityArrwoLeft] = useState("unset");
  const [translateXPosition, setTranslateXPosition] = useState(0);
  const [currentPosition, setCurrentPosition] = useState(0);

  let calculatedLength = blok.pictures.length - 4;
  let calculatedLengthTwo = blok.pictures.length - 2;

  function hideLeftArrow(){
    if(currentPosition < 1){
      setVisibilityArrwoLeft("hidden");
    }else if(currentPosition >= 1){
      setVisibilityArrwoLeft("unset");
    }
  }

  function hideRightArrow(){
    if(window.innerWidth > 1240){
      if(currentPosition == blok.pictures.length - 3){
        setVisibilityArrwoRight("hidden");
      }else if(currentPosition < blok.pictures.length - 3){
        setVisibilityArrwoRight("unset");
      }
    }

    if(window.innerWidth <= 1240 && window.innerWidth > 750){
      if(currentPosition == blok.pictures.length - 2){
        setVisibilityArrwoRight("hidden");
      }else if(currentPosition < blok.pictures.length - 2){
        setVisibilityArrwoRight("unset");
      }
    }

    if(window.innerWidth <= 750){
      if(currentPosition == blok.pictures.length - 1){
        setVisibilityArrwoRight("hidden");
      }else if(currentPosition < blok.pictures.length - 1){
        setVisibilityArrwoRight("unset");
      }
    }
  }

  useEffect(() => {
    hideLeftArrow();
    hideRightArrow();
  }, [currentPosition])
  

  function slideRight() {
    const instagramImages = document.getElementById("instagramImages");

    if (
      currentPosition >= 0 &&
      currentPosition <= calculatedLength &&
      window.innerWidth > 1240
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 34.32);
      instagramImages.style.transition = "0.5s ease-in-out";
   /*    console.log(blok.pictures.length); */
    } else if (
      currentPosition >= 0 &&
      currentPosition < calculatedLengthTwo &&
      window.innerWidth <= 1240 &&
      window.innerWidth > 850
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 51.5);
      instagramImages.style.transition = "0.5s ease-in-out";
    } else if (
      currentPosition >= 0 &&
      currentPosition < blok.pictures.length - 1 &&
      window.innerWidth <= 850
    ) {
      setCurrentPosition(currentPosition + 1);
      setTranslateXPosition(translateXPosition - 100);
      instagramImages.style.transition = "0.5s ease-in-out";
    }
  }

  function slideLeft() {
    const instagramImages = document.getElementById("products");

    if (currentPosition >= 1 && window.innerWidth > 1240) {
      setTranslateXPosition(translateXPosition + 34.32);
      setCurrentPosition(currentPosition - 1);
      instagramImages.style.transition = "0.5s ease-in-out";
    } else if (
      currentPosition >= 1 &&
      window.innerWidth <= 1240 &&
      window.innerWidth > 850
    ) {
      setCurrentPosition(currentPosition - 1);
      setTranslateXPosition(translateXPosition + 51.5);
      instagramImages.style.transition = "0.5s ease-in-out";
    } else if (currentPosition >= 1 && window.innerWidth < 850) {
      setCurrentPosition(currentPosition - 1);
      setTranslateXPosition(translateXPosition + 100);
      instagramImages.style.transition = "0.5s ease-in-out";
    }
  }
  return (
    <div className="wrap">
    <div className="instagramslider-wrap inner-wrap" {...storyblokEditable(blok)}>
      <h2 className="instagram-subheadline merriweather text-xl pb-6">
        {blok.subheadline}
      </h2>
      <div className="instagramslider-wrap-outer">
        <div style={{ visibility: `${arrowLeftVisibility}` }} className="arrow-box">
          <img
            onClick={slideLeft}
            className="arrow-left"
            src="/src/arrow-left-grey-89-48.png"
            alt=""
          />
        </div>
        <div className="instagram-wrap-slider flex">
          <div
            style={{ transform: `translateX(${translateXPosition}%)` }}
            className="instagram-content"
            id="instagramImages"
            {...storyblokEditable(blok)}
          >
            <div className="instagram-content-outer">
              {blok.pictures.map((nestedBlok) => (
                <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))}
            </div>
          </div>
        </div>
        <div style={{ visibility: `${arrowRightVisibility}` }} className="arrow-box">
          <img
            onClick={slideRight}
            className="arrow-right"
            src="/src/arrow-right-grey-25-48.png"
            alt=""
          />
        </div>
      </div>
      <h2 className="instagramslider-borderbottom merriweather text-xl pb-6"></h2>
    </div>
    </div>
  );
};
export default InstagramSliderWrap;
